import React, { createContext, useContext } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { getPlantData } from "./api";

const ValidationContext = createContext();

export const useValidationContext = () => useContext(ValidationContext);

function ValidationContextProvider({ children, plant: isPlant = false }) {
  const { plantId } = useParams();

  const [plant, setPlant] = useState({
    id: plantId ?? "",
    projects: [],
    drawings: [],
  });

  const [state, setState] = useState({
    loading: false,
    isError: false,
  });

  const fetchPlant = async () => {
    try {
      setState({ isLoading: true, isError: false });
      const res = await getPlantData(plantId);
      console.log("validation api res: ", res.data);

      const currentDrawings = [];

      res?.projects?.forEach((project) => {
        project?.drawings?.forEach((drawing) => {
          currentDrawings.push(drawing);
        });
      });

      setPlant({ ...plant, ...res, drawings: currentDrawings });
    } catch (err) {
      console.error("Error fetching plants:", err);
      setState({ isLoading: false, isError: true });
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  useEffect(() => {
    fetchPlant();
  }, []);

  return (
    <ValidationContext.Provider
      value={{
        plant,
        setPlant,
      }}
    >
      {children}
    </ValidationContext.Provider>
  );
}

export { ValidationContextProvider, ValidationContext };
